<template>
  <div class="admin-edit">
    <h2 class="page-title">{{ isEdit ? '编辑管理员' : '新增管理员' }}</h2>

    <div class="form-card">
      <div class="form-row">
        <label class="form-label">登录账号 <span class="required">*</span></label>
        <input v-model="form.username" class="form-input" placeholder="用于后台登录的账号" />
      </div>

      <div class="form-row">
        <label class="form-label">姓名</label>
        <input v-model="form.real_name" class="form-input" placeholder="管理员真实姓名" />
      </div>

      <div class="form-row">
        <label class="form-label">手机号</label>
        <input v-model="form.phone" class="form-input" placeholder="手机号" />
      </div>

      <div class="form-row">
        <label class="form-label">角色</label>
        <select v-model="form.role_id" class="form-input">
          <option :value="null">未分配</option>
          <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.role_name }}</option>
        </select>
      </div>

      <div class="form-row">
        <label class="form-label">绑定用户ID</label>
        <input v-model.number="form.user_id" type="number" class="form-input" placeholder="可选，关联前台 user.id（唯一）" />
        <p class="form-hint">用于将该管理员与某个前台用户绑定，可为空</p>
      </div>

      <div class="form-row">
        <label class="form-label">状态</label>
        <select v-model.number="form.status" class="form-input">
          <option :value="1">启用</option>
          <option :value="0">禁用</option>
        </select>
      </div>

      <div class="form-row">
        <label class="form-label">{{ isEdit ? '重置密码' : '密码' }} <span v-if="!isEdit" class="required">*</span></label>
        <input
          v-model="form.password"
          type="password"
          class="form-input"
          :placeholder="isEdit ? '留空则不修改密码' : '至少6位'"
        />
      </div>

      <p v-if="error" class="form-error">{{ error }}</p>

      <div class="form-actions">
        <button class="btn btn-primary" :disabled="submitting" @click="submit">
          {{ submitting ? '提交中...' : '保存' }}
        </button>
        <router-link to="/admin-accounts/list" class="btn btn-default">取消</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { getAdmins, createAdmin, updateAdmin, getRoles } from '@/api/system'

export default {
  name: 'AdminEdit',
  data() {
    return {
      isEdit: false,
      roles: [],
      form: {
        username: '',
        real_name: '',
        phone: '',
        role_id: null,
        user_id: null,
        status: 1,
        password: ''
      },
      submitting: false,
      error: ''
    }
  },
  async mounted() {
    this.loadRoles()
    const id = this.$route.params.id
    if (id) {
      this.isEdit = true
      await this.loadDetail(id)
    }
  },
  methods: {
    async loadRoles() {
      try {
        const res = await getRoles()
        const data = res.data || res || {}
        this.roles = data.data || data.list || data || []
      } catch (e) {
        this.roles = []
      }
    },
    async loadDetail(id) {
      try {
        const res = await getAdmins({ page: 1, per_page: 1000 })
        const data = res || {}
        const all = data.data || data.list || []
        const item = all.find(a => String(a.id) === String(id))
        if (item) {
          this.form = {
            username: item.username || '',
            real_name: item.real_name || '',
            phone: item.phone || '',
            role_id: item.role_id || null,
            user_id: item.user_id || null,
            status: item.status === 0 ? 0 : 1,
            password: ''
          }
        }
      } catch (e) {
        this.error = '加载管理员信息失败'
      }
    },
    async submit() {
      this.error = ''
      if (!this.form.username) {
        this.error = '请输入登录账号'
        return
      }
      if (!this.isEdit && !this.form.password) {
        this.error = '请输入密码'
        return
      }

      const payload = {
        username: this.form.username,
        real_name: this.form.real_name,
        phone: this.form.phone,
        role_id: this.form.role_id || null,
        user_id: this.form.user_id ? Number(this.form.user_id) : null,
        status: this.form.status
      }
      if (this.form.password) {
        payload.password = this.form.password
      }

      this.submitting = true
      try {
        if (this.isEdit) {
          await updateAdmin(this.$route.params.id, payload)
        } else {
          await createAdmin(payload)
        }
        this.$message && this.$message.success('保存成功')
        this.$router.push('/admin-accounts/list')
      } catch (e) {
        const msg = e.response && e.response.data && e.response.data.message
        this.error = msg || '保存失败'
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.page-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 20px;
}
.form-card {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  max-width: 520px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.form-row {
  margin-bottom: 18px;
}
.form-label {
  display: block;
  font-size: 14px;
  color: #333;
  margin-bottom: 6px;
}
.required {
  color: #e74c3c;
}
.form-input {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}
.form-hint {
  margin: 6px 0 0;
  font-size: 12px;
  color: #999;
}
.form-error {
  color: #e74c3c;
  font-size: 14px;
  margin-bottom: 12px;
}
.form-actions {
  display: flex;
  gap: 12px;
}
.btn {
  padding: 9px 22px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  text-decoration: none;
}
.btn-primary {
  background: #667eea;
  color: #fff;
}
.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.btn-default {
  background: #eee;
  color: #333;
}
</style>
